import { styled } from '@ltvco/refresh-lib/theme';

export const StyledImage: React.ComponentType<
  React.ImgHTMLAttributes<HTMLImageElement>
> = styled('img')({
  width: '104px',
  height: '64px',
  objectFit: 'contain',
});
